// extracted by mini-css-extract-plugin
module.exports = {"cart-item":"CartItem_cart-item__3kA3R","summary":"CartItem_summary__2ov4i","price":"CartItem_price__3Dkg1","amount":"CartItem_amount__18Xwp","actions":"CartItem_actions__9Cmg1"};